module.exports = __webpack_public_path__ + "img/3.b991e926.png";